/**
 * Keep the worklet same-origin. iOS Safari can reject or stall a Blob-backed
 * AudioWorklet module even after microphone permission succeeds, and the
 * production CSP deliberately permits same-origin scripts.
 */
export const PCM_CAPTURE_WORKLET_URL = '/pcm-capture-worklet.js';
